import React, { useState, useContext } from "react";
import { Button } from "../../Components";
import OtpInput from "./OtpInput";
import CountdownTimer from "../commonComponent/CountdownTimer";
import Header from "../commonComponent/Header";
import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import {
  unsubscribeConfirm,
  upgradeConfirm,
  subscriptionActivationConFirm,
  loginConfirm,
  checkSubcription,
  upgrade,
  unsubscribe,
  subscriptionActivation,
  login,
  subscribe
} from "../API/apiRequest";
import Loader from "../commonComponent/Loader";
import { Context } from "../../context/Context";
import { countryCode } from "../config/wapConfig";
import { Base64 } from "js-base64";

function Otp() {
  const TIME_LEFT_FOR_OTP = 120;
  const OTP_LENGTH = 4;
  const msisdn = localStorage.getItem("msisdn");
  const { type } = queryString.parse(window.location.search);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [isWrongOTP, setIsWrongOTP] = useState(false);
  const [otpTime, setOtpTime] = useState(TIME_LEFT_FOR_OTP);
  const [isLoader, setIsLoader] = useState(false);
  const { handleShowModal } = useContext(Context);
  const isButtonDisabled = otp.length < OTP_LENGTH;
  const uuid = localStorage.getItem('uuid') || ''
  const uid = `m=${countryCode.substring(1) + msisdn}`;
  const handleOtpVerify = () => {
    if (isButtonDisabled) {
      const modalData = {
        title: "Error",
        body: "يرجى ادخال رمز التحقق (OTP) الصحيح",
        buttons: [
          {
            label: "حسنًا",
            action: "close",
          },
        ],
        handleClick: function (value) {
          if (value === "close") {
            handleShowModal(false);
          }
        },
      };
      handleShowModal(true, modalData);
      return;
    }
    const msisdn = localStorage.getItem("msisdn");
    setIsLoader(true)
    setIsWrongOTP(false)
    if (type === "active") {
      loginConfirm(msisdn, otp, uuid)
        .then((resp) => {
          console.log("login confirm api resp::", resp);
          if (resp?.success) {
            if (localStorage.getItem("unsubUser") === "validity_exists") {
              navigate(`/home?uid=${Base64.encode(uid)}`)
            }
            else {
              navigate('/sub-status?type=subscribe&id=subscribe')
            }
          } else if (resp?.failed) {
            setIsLoader(false);
            const msgCode = resp?.messageCode
            if (msgCode == '01') {
              setIsWrongOTP(true)
            }
            const modalData = {
              title: "Error",
              body: (msgCode == '21' ? 'الرصيد غير كافٍ.' : msgCode == '01' ? '.رمز التحقق غير صحيح' : "حدث خطأ ما."),
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            setIsLoader(false);
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("err in subs api resp::", err);
        });
    }
    else if (type === "login") {
      // loginConfirm(msisdn, otp, uuid)
      loginConfirm(msisdn, otp, uuid)
        .then((resp) => {
          console.log("login confirm api resp::", resp);
          if (resp?.success) {
            checkSubcription(msisdn)
              .then((response) => {
                localStorage.setItem("userStatus", response?.subscriptionResponse?.currentStatus?.toLowerCase())
                localStorage.setItem("userStatusExipry", response?.subscriptionResponse?.cdrEndDate)
                const rawUTC = response?.subscriptionResponse?.cdrEndDate;
                const givenDateUTC = new Date(rawUTC?.replace(" ", "T") + "Z");
                const nowUTC = new Date();
                const checksubStatus = response?.subscriptionResponse?.currentStatus?.toLowerCase();
                if (checksubStatus === 'active') {
                  navigate('/sub-status?type=subscribe&id=7')
                }
                else if (checksubStatus === 'unsubscribed' && givenDateUTC.getTime() < nowUTC.getTime()) {
                  navigate(`/home?uid=${Base64.encode(uid)}`)
                }
                else if (checksubStatus === 'new' || checksubStatus === 'pending') {
                  subscribe(msisdn, 'daily')
                    .then((subsResponse) => {
                      let timeInterval = ''
                      let count = 3
                      let repeatTime = 5000;
                      timeInterval = setInterval(() => {
                        checkSubcription(msisdn)
                          .then((response) => {
                            localStorage.setItem("userStatus", response?.subscriptionResponse?.currentStatus?.toLowerCase())
                            localStorage.setItem("userStatusExipry", response?.subscriptionResponse?.cdrEndDate)
                            const checksubStatus = response?.subscriptionResponse?.currentStatus?.toLowerCase();
                            if (checksubStatus === 'active') {
                              setIsLoader(false);
                              navigate('/sub-status?type=subscribe&id=7')
                              clearInterval(timeInterval);
                            } else if (checksubStatus === 'pending' && count === 0) {
                              clearInterval(timeInterval)
                              setIsLoader(false);
                              const modalData = {
                                title: "Error",
                                body: "طلبك قيد التنفيذ. يرجى التحقق بعد فترة.",
                                messageCode: '',
                                buttons: [
                                  {
                                    label: "حسنًا",
                                    action: "close",
                                  },
                                ],
                                handleClick: function (value) {
                                  if (value === "close") {
                                    navigate('/')
                                    clearInterval(timeInterval);
                                    handleShowModal(false);
                                  }
                                  console.log("button clicked");
                                },
                              };
                              handleShowModal(true, modalData);

                            }

                            if (count === 0) {
                              setIsLoader(false);
                              clearInterval(timeInterval)
                            }
                            count = count - 1;
                          })
                          .catch((err) => {
                            clearInterval(timeInterval);
                            setIsLoader(false);
                            console.log("check sub api err::", err);
                          })

                      }, repeatTime)
                    })
                    .catch((err) => {
                      setIsLoader(false);
                      console.log("subs api err::", err);
                    })
                }
              })
              .catch((err) => {
                setIsLoader(false);
                console.log("check sub api err::", err);
              })
          } else if (resp?.failed) {
            setIsLoader(false);
            const msgCode = resp?.messageCode
            if (msgCode == '01') {
              setIsWrongOTP(true)
            }
            const modalData = {
              title: "Error",
              body: (msgCode == '21' ? 'الرصيد غير كافٍ.' : msgCode == '01' ? '.رمز التحقق غير صحيح' : "حدث خطأ ما."),
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            setIsLoader(false);
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("err in subs api resp::", err);
        });

    } else if (type === "unsub") {
      unsubscribeConfirm(msisdn, otp,  localStorage.getItem("uuid") || '')
        .then((resp) => {
          console.log("unsub confirm api response::", resp);
          if (resp?.messageCode == '00') {
            setIsLoader(false);
            const modalData = {
              title: "Success",
              body: 'تم إلغاء الاشتراك.',
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "okay",
                },
              ],
              handleClick: function (value) {
                if (value === 'okay') {
                  handleShowModal(false);
                  setIsLoader(true)
                  handleChecksub()
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);

          } else if (resp?.messageCode == '01') {
            setIsLoader(false);
            setIsWrongOTP(true)
            const modalData = {
              title: "Error",
              body: '.رمز التحقق غير صحيح',
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "okay",
                },
              ],
              handleClick: function (value) {
                if (value === "okay") {
                  navigate('/')
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);

          }
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("err in unsub confirm api::", err);
        });
    } else if (type === "upgrade") {
      const uuid = localStorage.getItem('uuid') || ''
      upgradeConfirm(msisdn, uuid, otp)
        .then((resp) => {
          console.log("response in upgrade api::", resp);
          if (resp?.messageCode == '00') {
            setIsLoader(false);
            navigate("/sub-status?type=plan_upgrade");
          } else {
            let msgCode = resp?.messageCode
            if (msgCode == '01') {
              setIsWrongOTP(true)
            }
            setIsLoader(false);
            const modalData = {
              title: "Error",
              body: 'فشل طلب الترقية الخاص بك. يرجى المحاولة مرة أخرى.',
              messageCode: '',
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          }
        })
        .catch((err) => {
          setIsLoader(false);
          console.log("err in upgrade api::", err);
        });
    } else if (type === "subscribe") {
      subscriptionActivationConFirm(msisdn, otp,  localStorage.getItem("uuid") || '')
        .then((resp) => {
          console.log("subs activate confirm api resp::", resp);
          if (resp?.messageCode == '00') {
            setIsLoader(false);
            const status = resp?.success?.status?.toLowerCase();
            if (status === "active") {
              navigate('/sub-status?type=subscribe&id=7')
            } else if (status === "pending") {
              navigate("/sub-status?type=pending");
            } else {
              navigate("/sub-status?type=subs_fail");
            }
          } else if (resp?.messageCode == '01') {
            setIsLoader(false);
            setIsWrongOTP(true)
            const modalData = {
              title: "Error",
              body: '.رمز التحقق غير صحيح',
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            setIsLoader(false);
            navigate("/sub-status?type=technical_error");
          }

        })
        .catch((err) => {
          setIsLoader(false);
          console.log("Error in subs confirm api ::", err);
        });
    } else {
      setIsLoader(false);
      navigate("/sub-status?type=technical_error");
    }
  };

  const handleChecksub = () => {
    setIsLoader(true)
    checkSubcription(msisdn)
      .then((response) => {
        setIsLoader(false)
        localStorage.setItem("userStatus", response?.subscriptionResponse?.currentStatus?.toLowerCase())
        localStorage.setItem("userStatusExipry", response?.subscriptionResponse?.cdrEndDate)
        const checksubStatus = response?.subscriptionResponse?.currentStatus?.toLowerCase();
        if (checksubStatus === 'active') {
          if (type === 'unsub') {
            navigate(`/home?uid=${Base64.encode(uid)}`)
          }
          else {
            navigate('/sub-status?type=subscribe&id=7')
          }
        } else if (checksubStatus === 'pending') {
          const modalData = {
            title: "Error",
            body: "طلبك قيد التنفيذ. يرجى التحقق بعد فترة.",
            messageCode: '',
            buttons: [
              {
                label: "حسنًا",
                action: "close",
              },
            ],
            handleClick: function (value) {
              if (value === "close") {
                navigate('/')
                handleShowModal(false);
              }
              console.log("button clicked");
            },
          };
          handleShowModal(true, modalData);

        }
        else {
          navigate("/");
          localStorage.setItem("uuid", "");
        }
      })
      .catch((err) => {
        console.log("check sub api err::", err);
      })
  }

  const handleResendOTP = () => {
    setIsLoader(false);
    setOtpTime(TIME_LEFT_FOR_OTP);
    if (type === 'login') {
      login(msisdn)
        .then((resp) => {
          setIsLoader(false);
          console.log("login resp::", resp);
          if (resp?.success) {
            // navigate(`/otp?type=login`);
          } else if (resp?.failed) {
            let msgCode = resp?.messageCode
            const modalData = {
              title: "Error",
              body: (msgCode == '300' ? 'هذه العملية غير مسموح بها' : msgCode == '05' ? 'لديك رمز تحقق واحد كل 10 ثوانٍ' : 'حدث خطأ ما.'),
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          setIsLoader(false);
          navigate("/sub-status?type=technical_error");
          console.log("error in login", err);
        });
    }
    else if (type === 'unsub') {
      unsubscribe(msisdn)
        .then((resp) => {
          console.log("unsub api resp::", resp)
          if (resp?.messageCode == '00') {
            // navigate(`/otp?type=unsub`)
          } else if (resp?.messageCode == '12') {
            const modalData = {
              title: "Error",
              body: 'تم إلغاء الاشتراك بالفعل.',
              messageCode: resp?.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          } else {
            navigate("/sub-status?type=technical_error");
          }

        })
        .catch((err) => {
          console.log("err in unsub api ::", err)
        })

    } else if (type === "upgrade") {
      const uuid = localStorage.getItem("uuid") || 'na';
      upgrade(msisdn, uuid)
        .then((resp) => {
          console.log("upgrade plan api::", resp);
          if (resp?.messageCode == '00') {
            // navigate(`/otp?type=upgrade`);
          } else {
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          console.log("err in upgrade api ::", err);
        });

    } else if (type === "subscribe") {
      subscriptionActivation(msisdn)
        .then((resp) => {
          console.log("subs api resp::", resp);
          setIsLoader(false);
          if (resp?.messageCode == '00') {
            // navigate(`/otp?type=subscribe`);
          }
          else if (resp?.messageCode == '01') {
            const modalData = {
              title: "Error",
              body: 'الاشتراك نشط بالفعل.',
              messageCode: resp.messageCode,
              buttons: [
                {
                  label: "حسنًا",
                  action: "okay",
                },
              ],
              handleClick: function (value) {
                if (value === "okay") {
                  navigate('/')
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          }
          else {
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          console.log("error in usb api::", err);
          setIsLoader(false);
          navigate("/sub-status?type=technical_error");
        });
    }

  };

  return (
    <>
      {isLoader && <Loader />}
      <div className="bg-darkPurple flex flex-col h-screen">
        <Header />
        <div className="flex-grow mt-36">
          <div className="mt-2 flex text-center flex-col items-center text-white">
            <div className="h-20 w-20 rounded-full mb-2 mt-12">
              <img
                src={
                  isWrongOTP
                    ? require("../..//Assets/wap/daretoknowAssets/wrong_otp.png")
                    : require("../../Assets/wap/daretoknowAssets/otp.png")
                }
              />
            </div>
            <div className="font-semibold text-3xl">
              {isWrongOTP === true ? "عذرًا" : "رمز التحقق"}
            </div>
            <div className="my-4">
              <div dir="rtl" className="max-w-80 w-80">
                {isWrongOTP
                  ? "رمز التحقق الذي أدخلته غير صحيح."
                  : "يرجى إدخال الرمز المكون من 4 أرقام الذي استلمته على رقم هاتفك."}
              </div>
              {isWrongOTP && (
                <div className="text-buttonYellow text-lg mb-4">حاول مرة أخرى.</div>
              )}
            </div>

            <OtpInput length={OTP_LENGTH} setOtp={setOtp} otp={otp} />
            <div className="w-70 mt-4 flex">
              احصل على رمز التحقق على رقم هاتفك في{" "}
              <span className="text-buttonYellow ml-2">
                <CountdownTimer initialTime={otpTime} />
              </span>
            </div>
            <div>
              لم تستلم الرسالة النصية؟
              <span
                onClick={handleResendOTP}
                className="text-buttonYellow cursor-pointer ml-2 font-semibold"
              >
                إعادة إرسال الرمز
              </span>
            </div>
            <Button
              name="التأكيد"
              handleClick={handleOtpVerify}
              className={`h-10 mt-8 rounded-full font-semibold text-lg px-4 w-80 ${isButtonDisabled ? 'opacity-50 cursor-not-allowed bg-buttonYellow' : 'bg-buttonYellow text-darkPurple'}`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Otp;
